import AssistanceLading from './AssistanceLanding';

export default AssistanceLading;



// WEBPACK FOOTER //
// ./src/components/AssistanceLanding/index.js